import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import UploadExam from "@/pages/UploadExam";
import ExamSimulation from "@/pages/ExamSimulation";
import ExamResults from "@/pages/ExamResults";
import History from "@/pages/History";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import PublicProfile from "@/pages/PublicProfile";
import DuelPage from "@/pages/DuelPage";
import WeeklyWrappedPublic from "@/pages/WeeklyWrappedPublic";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-stone-500 font-mono text-sm">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Auth />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/upload" element={<Protected><UploadExam /></Protected>} />
      <Route path="/exam/:examId" element={<Protected><ExamSimulation /></Protected>} />
      <Route path="/results/:attemptId" element={<Protected><ExamResults /></Protected>} />
      <Route path="/history" element={<Protected><History /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/u/:username" element={<PublicProfile />} />
      <Route path="/w/:username" element={<WeeklyWrappedPublic />} />
      <Route path="/duel/:code" element={<DuelPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
